module.exports = __webpack_public_path__ + "static/media/bg-gradient-half.91f8b767.png";